import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
var NavContext = /*#__PURE__*/createContext();
export function NavProvider(_ref) {
  var {
    children
  } = _ref;
  var [activeMobilePanel, setActiveMobilePanel] = useState(null);
  var [headerVisible, setHeaderVisible] = useState(true);
  var [headerHeight, setHeaderHeight] = useState(0);
  var openMenu = useCallback(() => setActiveMobilePanel('menu'), []);
  var openSearch = useCallback(() => setActiveMobilePanel('search'), []);
  var closeAll = useCallback(() => setActiveMobilePanel(null), []);
  var toggleMenu = useCallback(() => {
    setActiveMobilePanel(prev => prev === 'menu' ? null : 'menu');
  }, []);
  var toggleSearch = useCallback(() => {
    setActiveMobilePanel(prev => prev === 'search' ? null : 'search');
  }, []);
  var value = useMemo(() => ({
    activeMobilePanel,
    openMenu,
    openSearch,
    closeAll,
    toggleMenu,
    toggleSearch,
    headerVisible,
    headerHeight,
    setHeaderVisible,
    setHeaderHeight
  }), [activeMobilePanel, openMenu, openSearch, closeAll, toggleMenu, toggleSearch, headerVisible, headerHeight, setHeaderVisible, setHeaderHeight]);
  return /*#__PURE__*/React.createElement(NavContext.Provider, {
    value: value
  }, children);
}
NavProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export var useNav = () => {
  var context = useContext(NavContext);
  if (context === undefined) {
    throw new Error('useNav must be used within a NavProvider');
  }
  return context;
};